<template>
  <v-card class="px-6 py-2 elevation-0">
    <v-row class="flex-nowrap">
      <v-col class="col-grow">
        <v-card-title :class="`subtitle-1 ${titleColor}--text font-weight-bold pl-0 pt-2 pb-3`">
          Contacts
        </v-card-title>

        <v-card-subtitle class="pa-0 caption">
          The people important to you.
        </v-card-subtitle>
      </v-col>

      <v-col class="col-auto px-0">
        <v-card-actions class="pl-3">
          <v-btn
            color="darkblue"
            icon
            small
            @click.stop="editContactsList"
          >
            <v-icon>
              group
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-col>
    </v-row>

    <v-row class="pb-6 mt-0">
      <v-col>
        <v-row>
          <v-list
            dense
          >
            <v-list-item
              v-for="(contact, contactIndex) in contactsToDisplay"
              :key="contactIndex"
              :href="contact.href"
              class="px-0"
              dense
              link
            >
              <v-list-item-content>
                <v-list-item-title>
                  <span class="text-smaller pa-3">
                    {{ contact.personName }}
                  </span>
                </v-list-item-title>

                <v-list-item-subtitle>
                  <span class="text-smaller pa-3">
                    {{ contact.relationships.join(', ') }}
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-row>

        <v-row>
          <v-btn
            v-if="contacts.length > 5"
            color="primary"
            text
            x-small
            class="d-flex text-smaller pa-3"
            @click="toggleAllContacts"
          >
            <span>
              {{ SHOW_ALL_CONTACTS ? `Collapse contacts` : `Reveal all ${ contacts.length } contacts` }}
            </span>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapAuthGetters, mapState: mapAuthState } = createNamespacedHelpers('auth')
const { mapGetters: mapLayoutGetters, mapState: mapLayoutState } = createNamespacedHelpers('layout')
const { mapGetters: mapToolsGetters } = createNamespacedHelpers('tools')

export default {
  name: 'ContactList',
  // components: {
  //   FormContact: () => import('src/layout/components/FormContact'),
  // },
  data: () => ({
    TOTAL_CONTACTS_TO_DISPLAY_BY_DEFAULT: 5,
    TOTAL_CONTACTS_TO_DISPLAY: 5,
    SHOW_ALL_CONTACTS: false,
  }),
  computed: {
    ...mapAuthGetters(['isInternalUser', 'network']),
    ...mapAuthState({
      user: (state) => state.user,
    }),
    ...mapToolsGetters(['contacts']),
    ...mapLayoutGetters(['titleColor']),
    ...mapLayoutState({
      formContact: (state) => state.formContact,
      isModalVisibleContact: (state) => state.isModalVisibleContact,
    }),
    formData: {
      get() {
        return this.formContact
      },
      set(value) {
        this.$store.commit('layout/formContact', value)
      },
    },
    entry: {
      get() {
        return this.formData.entry
      },
      set(entry) {
        const { action } = this.formData
        this.$store.commit('layout/formContact', {
          action,
          entry,
        }, { root: true })
      },
    },
    showContactForm: {
      get() {
        return this.isModalVisibleContact
      },
      set(newValue) {
        this.$store.commit('layout/isModalVisibleContact', newValue)
      },
    },
    contactsToDisplay() {
      return this.contacts.slice(0, this.TOTAL_CONTACTS_TO_DISPLAY)
    },
  },
  methods: {
    editContactsList() {
      this.entry = this.bookmarks
      this.showContactForm = true
    },
    editContact(contact) {
      this.entry = [contact]
      this.showContactForm = true
    },

    toggleAllContacts() {
      if (this.SHOW_ALL_CONTACTS) {
        this.TOTAL_CONTACTS_TO_DISPLAY = this.TOTAL_CONTACTS_TO_DISPLAY_BY_DEFAULT
      } else {
        this.TOTAL_CONTACTS_TO_DISPLAY = this.contacts.length
      }
      this.SHOW_ALL_CONTACTS = !this.SHOW_ALL_CONTACTS
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~src/styles/lists.scss';
</style>
